<template>
  <div id="google_translate_element"></div>
</template>

<script>
export default {
  name: 'AppGoogleTranslator',
};
</script>

<style scoped>
#google_translate_element {
  display: flex;
  justify-content: flex-end;
  position: relative;
  margin-bottom: 15px;
  top: 10px;
}
</style>
